import { _Componentes_WebApiCalls_Post, _Componentes_WebApiCalls_PostBlob } from "../ComponentesGlobales/WebApiCalls";
import { crearRequestEmision } from "./facturacionElectronicaUtils";
export * from "./facturacionElectronicaUtils";

const contextoFiscal = (EmpresaId, facturaId) => ({
  EmpresaId,
  facturaId: Number(facturaId) || 0,
});

export const emitirFacturaElectronica = (parametros) =>
  _Componentes_WebApiCalls_Post("Facturacion078/Electronica", crearRequestEmision(parametros));

export const consultarEstadoFactura = ({ EmpresaId, facturaId }) =>
  _Componentes_WebApiCalls_Post("Facturacion078/Estado", contextoFiscal(EmpresaId, facturaId));

export const reintentarFacturaElectronica = (parametros) =>
  _Componentes_WebApiCalls_Post("Facturacion078/ReintentarElectronica", crearRequestEmision(parametros));

export const obtenerPendientesArca = (EmpresaId) =>
  _Componentes_WebApiCalls_Post("Facturacion078/PendientesArca", { EmpresaId });

export const obtenerComprobanteDatos = ({ EmpresaId, facturaId, formato = "Ticket80" }) =>
  _Componentes_WebApiCalls_Post("Facturacion078/ComprobantePdfDatos", {
    ...contextoFiscal(EmpresaId, facturaId),
    formato,
    copia: "ORIGINAL",
  });

export const descargarComprobante = ({ EmpresaId, facturaId, formato = "A4" }) =>
  _Componentes_WebApiCalls_PostBlob("Facturacion078/ComprobantePdf", {
    ...contextoFiscal(EmpresaId, facturaId),
    formato,
    copia: "ORIGINAL",
  });
